import React from "react";
import { styled } from "styled-components";
import rem from "../../utils/rem";
import Colors from "../../styles/Colors";
const StyledTextButton = styled.button `
  all: revert;
  color: ${Colors.GRAY_DARKEST};
  letter-spacing: ${rem(0.4)};
  font-weight: 800;
  text-decoration: underline;
  &:hover,
  &:focus {
    text-decoration-line: underline;
    color: ${Colors.GRAY_DARK};
  }
  &:active {
    color: ${Colors.GRAY_DARKEST};
  }
  font-size: ${rem(16)};
  line-height: ${rem(18)};
  border: none;
  cursor: pointer;
  background: none;
  padding: 0;
  margin: 0;
`;
const TextButton = (props) => React.createElement(StyledTextButton, { ...props });
export default TextButton;
//# sourceMappingURL=TextButton.js.map